import axios from "../../services/axios";
import { Currency } from "./settingsType/Currency";

interface GetAllParams {
  query: any;
}

interface CreateParams {
  query: any;
}

const CurrencyService = {
  getAll: async ({ query }: GetAllParams) => {
    try {
      const res = await axios.get(`/currencies?${query}`);
      return {
        data: res.data.data,
        pagination: res.data.meta.pagination,
      };
    } catch (error) {
      console.error("Error fetching players:", error);
      throw error;
    }
  },

  create: async (payload: Currency) => {
    try {
      const response = await axios.post(
        `/currencies`,
        { data: payload }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating currency:", error);
      throw error;
    }
  },
  
  update: async (id: string, payload: Currency) => {
    try {
      const response = await axios.put(
        `/currencies/${id}`,
        { data: payload }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating currency:", error);
      throw error;
    }
  },

  delete: async (id: string) => {
    try {
      const response = await axios.delete(`/currencies/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting currency:", error);
      throw error;
    }
  },
};

export default CurrencyService;
